// extracted by mini-css-extract-plugin
export var bottomRightDock = "_3q-0";